<tr>
    <th *ngIf="datatable.collapsing"></th>
    <ng-container *ngFor="let col of datatable.columnas; let i = index">
        <!-- <th *ngIf="col.mostrar !== false"> -->
        <th [hidden]="!(col.mostrar !== false)">
            <div class='table-header' [ngbTooltip]="col.tooltip ? col.tooltip : null">
                <div>{{col.nombre}}</div>
                <div class='d-inline-block text-right'>
                    <div class='click d-inline-block'>
                        <div 
                            #sortDrop="ngbDropdown" 
                            ngbDropdown
                            display="dynamic"
                            container="body"
                        >
                            <i *ngIf="col.sort" [ngClass]="'fas fa-' + getSortClass(col)" id="menuSort" ngbDropdownToggle>
                                <div ngbDropdownMenu aria-labelledby="menuSort" class='dropdown-sort'>
                                    <button ngbDropdownItem 
                                        *ngIf="hasToShow(col, sortData.CLASS_ASC)"
                                        (click)="sortClickeado(col, sortData.CLASS_ASC)"
                                    >
                                        <strong>Ascendente</strong>
                                    </button>
                                    <button ngbDropdownItem 
                                        *ngIf="hasToShow(col, sortData.CLASS_DESC)"
                                        (click)="sortClickeado(col, sortData.CLASS_DESC)"
                                    >
                                        <strong>Descendente</strong>
                                    </button>
                                    <button ngbDropdownItem 
                                        *ngIf="hasToShow(col, sortData.CLASS_NONE)" 
                                        class='text-danger'
                                        (click)="sortClickeado(col, sortData.CLASS_NONE)"
                                    >
                                        <strong>Remover</strong>
                                    </button>
                                </div>
                            </i>
                        </div>
                    </div>
                    <div class='click d-inline-block icon-button' [hidden]="!col.filterKey">
                        <div 
                            #myDrop="ngbDropdown" 
                            ngbDropdown
                            display="dynamic"
                            container="body"
                        >
                            <i class="fas fa-filter" [ngClass]="contarFiltros(i) > 0 ? 'filtro-selected' : ''" 
                                id="menuFilter" ngbDropdownToggle [hidden]="!col.filterKey"> 
                                <div ngbDropdownMenu aria-labelledby="menuFilter" style="z-index:10000;">
                                    <div class='filtros p-10' [hidden]="!col.filterKey" [ngClass]="isProductoFiltro(i) ? 'filtros-articulos' : ''">
                                        <app-filtro-magico 
                                            [id]="id"
                                            *ngIf="thFiltros[i].filtrosMagicos"
                                            [emitirFiltrosDefecto]="false"
                                            [filtros]="thFiltros[i].filtrosMagicos"
                                            (onFiltrosModelCambiados)="filtrosModelCambiado(i, $event)"
                                            [isMaster]="false"
                                        >
                                        </app-filtro-magico>
                                    </div>
                                </div>
                            </i>
                        </div>
                    </div>
                </div>
            </div>
        </th>
    </ng-container>
</tr>